const RECENT_INFORM_MS = 60 * 60 * 1000;

export function getTr069DisplayStatus(device, now = Date.now()) {
  const rawStatus = String(device?.cwmp_status || device?.state || '').trim().toLowerCase();
  if (rawStatus === 'fault') return 'fault';
  const lastInform = device?.last_inform;
  if (!lastInform) return rawStatus || 'not informed';
  const value = String(lastInform).trim();
  const iso = value.includes('T') ? value : value.replace(' ', 'T');
  const withTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(iso) ? iso : `${iso}Z`;
  const lastInformMs = Date.parse(withTimezone);
  if (!Number.isFinite(lastInformMs)) return rawStatus || 'unknown';
  return now - lastInformMs <= RECENT_INFORM_MS ? 'online' : 'stale';
}
